import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { GET_IMPORT_CSV_STATUS_QUERY, ImportCsvStatusResponse } from './type';

const getImportStatus = async (importId?: string) => {
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/nightgraph/import/${importId}/status`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetImportStatus = ({
  importId,
  options,
}: {
  importId?: string;
  options?: Record<string, boolean | number>;
}) => {
  return useGenericQuery<ImportCsvStatusResponse, RequestError>(
    [GET_IMPORT_CSV_STATUS_QUERY, importId],
    () => getImportStatus(importId),
    {
      ...options,
    }
  );
};
